import React from 'react';
import { LayersIcon, PlusCircleIcon, CpuIcon, FileTextIcon, ArrowRightIcon } from 'lucide-react';
interface StepProps {
  number: number;
  icon: React.ReactNode;
  title: string;
  description: string;
  isLast?: boolean;
}
function Step({
  number,
  icon,
  title,
  description,
  isLast
}: StepProps) {
  return <div className="relative flex flex-col items-center text-center group">
      {/* Connector line */}
      {!isLast && <div className="hidden md:block absolute top-10 left-[calc(50%+40px)] w-[calc(100%-80px)] h-[2px]">
          <div className="w-full h-full bg-gradient-to-r from-primary-500/50 to-primary-500/20" />
          <ArrowRightIcon className="absolute -right-2 -top-2 w-5 h-5 text-primary-500/50" />
        </div>}

      {/* Step number */}
      <div className="relative">
        <div className="w-20 h-20 rounded-2xl bg-surface-700 border border-surface-500 flex items-center justify-center mb-6 group-hover:border-primary-500/50 transition-colors">
          <div className="text-primary-400">{icon}</div>
        </div>
        <div className="absolute -top-2 -left-2 w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center text-sm font-bold text-white">
          {number}
        </div>
      </div>

      <h3 className="text-lg font-semibold text-white mb-2">{title}</h3>
      <p className="text-gray-400 text-sm leading-relaxed max-w-[200px]">
        {description}
      </p>
    </div>;
}
export function HowItWorks() {
  return <section className="py-32 px-6 bg-surface-800/50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-20">
          <p className="text-primary-400 font-medium mb-4">How It Works</p>
          <h2 className="text-4xl font-bold text-white mb-6">
            Four steps to autonomous execution
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            StreamGraph handles the complexity so you can focus on what matters.
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-8">
          <Step number={1} icon={<LayersIcon className="w-8 h-8" />} title="Define streams" description="Create parallel workstreams for different aspects of your project." />
          <Step number={2} icon={<PlusCircleIcon className="w-8 h-8" />} title="Add tasks dynamically" description="Tasks appear as nodes in your graph, with dependencies automatically tracked." />
          <Step number={3} icon={<CpuIcon className="w-8 h-8" />} title="Let agents execute" description="AI agents work through tasks autonomously, only interrupting when needed." />
          <Step number={4} icon={<FileTextIcon className="w-8 h-8" />} title="Export documentation" description="Reports and docs generate themselves from your execution history." isLast />
        </div>
      </div>
    </section>;
}